import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae62eb7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Editing flashcards in deck", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create a new flashcard for this deck:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "…or, choose cards to add:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "extra-contrast-option-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_IonSearchbar = _resolveComponent("IonSearchbar")!
  const _component_IonListHeader = _resolveComponent("IonListHeader")!
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonRadio = _resolveComponent("IonRadio")!
  const _component_IonItem = _resolveComponent("IonItem")!
  const _component_IonList = _resolveComponent("IonList")!
  const _component_IonRadioGroup = _resolveComponent("IonRadioGroup")!
  const _component_IonCheckbox = _resolveComponent("IonCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, [
      _hoisted_1,
      _createTextVNode(),
      _createVNode(_component_IonIcon, {
        icon: _ctx.arrowBackCircleOutline,
        class: "quick-back",
        onClick: _ctx.dismiss,
        alt: "back"
      }, null, 8, ["icon", "onClick"])
    ]),
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_IonButton, {
      class: "make-a-flashcard",
      onClick: _ctx.createCard
    }, {
      default: _withCtx(() => [
        _createTextVNode("Make a flashcard")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_component_IonSearchbar, {
          mode: "md",
          class: "max-width center",
          placeholder: "Search for a card",
          modelValue: _ctx.cardInput,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardInput) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_IonRadioGroup, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
          class: "deck-chooser--filter"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IonListHeader, { class: "main-label extra-contrast-option-list" }, {
              default: _withCtx(() => [
                _createTextVNode("Limit to")
              ]),
              _: 1
            }),
            _createVNode(_component_IonList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, ({ value, text }) => {
                  return (_openBlock(), _createBlock(_component_IonItem, { key: value }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IonLabel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_IonRadio, {
                        mode: "ios",
                        value: value
                      }, null, 8, ["value"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("form", null, [
        _createVNode(_component_IonList, { "radio-group": "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewableCards, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.id
              }, [
                _createVNode(_component_IonItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IonCheckbox, {
                      onIonChange: ($event: any) => (_ctx.toggleCard(card.id)),
                      checked: _ctx.cards.includes(card.id),
                      class: "center-text center card-check"
                    }, null, 8, ["onIonChange", "checked"]),
                    _createVNode(_component_IonLabel, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Select: " + _toDisplayString(card.kaska) + " - " + _toDisplayString(card.english), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_IonButton, {
        class: "select-image--return",
        color: "secondary",
        fill: "outline",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonIcon, { icon: _ctx.returnDownBackOutline }, null, 8, ["icon"]),
          _createTextVNode(" Done ")
        ]),
        _: 1
      })
    ])
  ], 64))
}